<template>
    <div class="order-detail" v-if="data.id">
        <div class="common-box">
            <div class="o-title">案件流转单</div>
            <div class="order-detail-container">
                <div class="item">
                    <div class="item-title">订单号：<span class="num-family">{{data.orderNo}}</span></div>
                    <div>创建人：{{data.orderCreateUserName}}({{data.orderCreateDeptName}})</div>
                    <div>创建时间：{{data.createTime}}</div>
                </div>
                <div class="item">
                    <div class="item-title">案号：<span class="num-family">{{data.caseArchivedNumber}}</span></div>
                    <div>类型：{{data.type}}</div>
                    <div>优先级：<span class="red">{{data.orderPersonalData.priority}}</span></div>
                </div>
                <div class="item">
                    <div class="item-title">初级计划单号：<span class="num-family">{{data.initialPlanNo}}</span></div>
                    <div>状态：{{data.status}}</div>
                </div>
            </div>
        </div>
        <div class="common-box mt10">
            <div class="o-title">用户信息</div>
            <div class="order-detail-container">
                <div class="item">
                    <div>用户姓名：{{data.orderPersonalData.name}}</div>
                    <div>身份证：{{data.orderPersonalData.cardNo}}</div>
                    <div>户籍地址：{{data.orderPersonalData.residenceProvince}}{{data.orderPersonalData.residenceCity}}{{data.orderPersonalData.residenceDistrict}}{{data.orderPersonalData.residenceAddress}}</div>
                </div>
                <div class="item">
                    <div>用出生年月：{{data.orderPersonalData.birthday}}</div>
                    <div>健康状态：{{data.orderPersonalData.healthyState}}</div>
                    <div>现住地址：{{data.orderPersonalData.actualResidenceProvince}}{{data.orderPersonalData.actualResidenceDistrict}}{{data.orderPersonalData.actualResidenceDistrict}}{{data.orderPersonalData.actualResidentialAddress}}</div>
                </div>
                <div class="item">
                    <div>籍贯：{{data.orderPersonalData.nativePlace}}</div>
                    <div>联系方式：{{data.orderPersonalData.contact}}</div>
                </div>
            </div>
            <div class="order-detail-container">
                <div class="item">就学状况：{{data.orderSocialSurvey.studentStatus}} {{data.orderSocialSurvey.school}} {{data.orderSocialSurvey.theGrade}} {{data.orderSocialSurvey.theClass}} {{data.orderSocialSurvey.studentNo}} {{data.orderSocialSurvey.studyResult}}</div>
            </div>
            <div class="order-detail-container">
                <div class="item">曾使用相关服务记录：{{data.orderPersonalData.isServiceSituation}}{{data.orderPersonalData.serviceSituationRemarks}}</div>
            </div>
            <div class="order-detail-container">
                <div class="item">现使用相关服务记录：{{data.orderPersonalData.serviceSituationRecord}}{{data.orderPersonalData.serviceSituationNow}}</div>
            </div>
            <kinship class="mt20" :list="data.orderKinshipList" :isShowBtn="false" :isOpt="false" :orderId="data.id"></kinship>
        </div>
        <div class="common-box mt10">
            <div class="o-title">情况描述</div>
            <div class="order-detail-container">
                <div class="item">
                    <div>案件类型：{{data.crimeTypeName}}</div>
                    <div>涉案场所：{{data.placeTypeName}}</div>
                </div>
                <div class="item">
                    <div>涉案时间：{{data.crimeTime}}</div>
                </div>
                <div class="item">
                    <div>涉案区域：{{data.regionCodeName}}</div>
                </div>
            </div>
            <div class="order-detail-container">
                <div class="item">
                    <div>情况描述：{{data.crimeSituation}}</div>
                </div>
            </div>
        </div>
        <!-- <div class="common-box mt10">
            <div class="o-title">案件详情</div>
            <div class="order-detail-container">
                <div class="item">
                    <div>{{data.detail}}</div>
                </div>
            </div>
        </div> -->
        <div class="common-box mt10">
            <orderinit class="mt20" :isShowBtn="false" :list="data.orderInitialPlanList" :isOpt="false" :orderId="data.id"></orderinit>
            <!-- <div class="o-title">初始计划单</div> -->
        </div>
        <div class="common-box mt10">
            <orderjudicial class="mt20" :isShowBtn="false" :list="data.starOrderJudicialList" :isOpt="false" :tips="true" :orderId="data.id"></orderjudicial>
        </div>
        <div class="common-box mt10">
            <orderlp class="mt20" :tips="true" :orderId="data.id" :expire="expire" :list="data.orderInitialPlanList"></orderlp>
        </div>
        <div class="tac mt20">
            <el-button type="primary" size="mini" @click="orderDispatchVisible = true">派单记录</el-button>
            <el-button type="primary" size="mini" @click="orderDetailVisible = true">查看计划单</el-button>
            <!-- <el-button type="primary" size="mini" @click="orderDetailVisible = true">打印初始计划单</el-button> -->
            <el-button type="primary" size="mini" @click="generatePlan" v-if="!expire">流转派单至执行机构</el-button>
            <el-button type="primary" size="mini" @click="goback" >返回</el-button>
        </div>
        <el-dialog title="订单详情" fullscreen append-to-body width="80%" :visible.sync="orderDetailVisible">
            <pdf :info="data" @close="orderDetailVisible = false"></pdf>
        </el-dialog>
        <el-dialog title="派单记录" fullscreen append-to-body width="80%" :visible.sync="orderDispatchVisible" v-if="orderDispatchVisible">
            <dispatchRecord :orderId="$route.query.id" :date="new Date()"></dispatchRecord>
        </el-dialog>
    </div>
</template>
<script>
import kinship from '@/components/kinship/index.vue'
import orderinit from '@/components/orderinit/index.vue'
import orderlp from '@/components/orderlp/index.vue'
import orderjudicial from '@/components/orderjudicial/index.vue'
import pdf from '@/views/archives/components/lzjh-pdf.vue'
import dispatchRecord from '@/components/orderlp/record.vue'
import { getOrderInfo, updateStatus, generatePlanHandle } from "@/api/order/index";
import { getDictionary } from '@/api/system/dictbiz'
export default {
    name: 'order-detail',
    components: {
        kinship,
        orderinit,
        orderjudicial,
        orderlp,
        pdf,
        dispatchRecord
    },
    mounted() {
        this.id = this.$route.query.id;
        this.expire = this.$route.query.expire
        if (this.id) {
            this.getDetail()
        }
    },
    data() {
        return {
            id: '',
            data: {},
            orderDetailVisible: false,
            expire: false,
            orderDispatchVisible: false
        }
    },
    methods: {
        goback(){
            this.$router.push({
                name: 'order'
            })
        },
        filterOrderInit() {
            return this.data.orderInitialPlanList.filter(v => {
                return v.deptId && v.content
            })
        },
        async getDictByValue(key, value, code, type) {
            let res = await getDictionary({ code: code })
            let obj = res.data.data.find(v => v.dictKey == value)
            if (!obj) return
            if (type == 1) {
                this.$set(this.data, key, obj.dictValue)
            } else if (type == 2) {
                this.$set(this.data.orderPersonalData, key, obj.dictValue)
            } else {
                this.$set(this.data.orderSocialSurvey, key, obj.dictValue)
            }

        },
        getDetail() {
            getOrderInfo(this.id).then(res => {
                this.data = res.data.data
                this.getDictByValue('type', this.data.type, 'work_type', 1)
                this.getDictByValue('status', this.data.status, 'order_status', 1)
                this.getDictByValue('priority', this.data.orderPersonalData.priority, 'priority', 2)
                this.getDictByValue('isServiceSituation', this.data.orderPersonalData.isServiceSituation, 'yes_no', 2)
                this.getDictByValue('serviceSituationRecord', this.data.orderPersonalData.serviceSituationRecord, 'yes_no', 2)
                this.getDictByValue('healthyState', this.data.orderPersonalData.healthyState, 'healthy', 2)
                this.getDictByValue('studentStatus', this.data.orderSocialSurvey.studentStatus, 'yes_no', 3)
            })
        },
        changeStatusHandle(val) {
            updateStatus(this.id, val).then(res => {
                this.$message.success("已完成派单")
                this.$router.$avueRouter.closeTag()
                this.$router.go(-1)
            })
        },
        generatePlan() {
            generatePlanHandle(this.data.id).then(res => {
                this.$message.success("已流转派单至执行机构")
            })
        }
    }

}

</script>
<style lang="scss" scoped="scoped">
@import "@/styles/moudles/order.scss";

</style>
